// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// require('vue-video-player/node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'babel-polyfill'
import GlobalCss from './assets/global-ui.css'
import './assets/css/style.css'
// import './assets/css/nuistyle.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import _promise from 'es6-promise'
import axios from 'axios'
import Mint from 'mint-ui'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import 'iview/dist/iview.min.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoPlayer from 'vue-video-player'
import utils from './utils'; //获取url参数
import store from './store/index'
import Vuex from 'vuex' //引入vuex
//import setTitle from './assets/script/settitle.js'
import setTitle from './assets/script/settiltle'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Viewer from 'v-viewer'

import 'viewerjs/dist/viewer.css'

window.setTitle = setTitle;
Vue.prototype.$utils = utils; //注册全局方法
Vue.prototype.$ajax = axios


// 引入底部公共组件
import Bottom from  './components/public/bottom/index.js'
Vue.use(Bottom);
// 引入底部合作伙伴
import BottomPartner from './components/public/bottomPartner/index.js'
Vue.use(BottomPartner)
// 引入头部公共组件
import HeaderBanner from './components/public/HeaderBanner/index.js'
Vue.use(HeaderBanner)
// import Header from './components/public/header/index.js'
// Vue.use(Header)
// 引入导航公共组件
import Navia from './components/public/naviagation/index.js'
Vue.use(Navia)
// 引入公共左侧
import PubLeft from './components/public/pubLeft/index.js'
Vue.use(PubLeft)
// 引入右侧公共
import PubRight from './components/public/pubRight/index.js'
Vue.use(PubRight)
// 引入右侧公共
import EnLeft from './components/english/engleft/index.js'
Vue.use(EnLeft)

_promise.polyfill();

Vue.config.productionTip = false;
Vue.prototype.$ajax = axios;
Vue.config.devtools = true;
Vue.use(VideoPlayer);
Vue.use(VueAwesomeSwiper);
Vue.use(axios);
Vue.use(Vuex);
Vue.use(store);
Vue.use(ElementUI);

//配置默认host

axios.defaults.baseURL = '/api'

// axios.defaults.baseURL = 'xhwkzz.boyuancb.com'

axios.interceptors.request.use(
  config => {
    config.headers.Authorization = 'Bearer test';
    return config;
  },
  err => {
    console.log(err);
    return Promise.reject(err);
  });
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
})

// 路由变化
router.afterEach(function(to) {
  if (to.meta && to.meta.title) {
    setTitle(to.meta.title);
  }
})

/* eslint-disable no-new */
var vm = new Vue({
  store,
  el: '#app',
  router,
  data() {
    return {
      isWeiXin: false,
      toPath: ''
    }
  },
  template: '<App/>',
  components: { App },
  updated() {

  },
  created() {
    let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 }
    if (isWeiXin()) {
      isWeiXin = true;
    } else {
      isWeiXin = false;
    }
    console.log('isWeiXin:' + isWeiXin);
  },
})



// WEBPACK FOOTER //
// ./src/main.js